import { booleanPointInPolygon, polygon } from "@turf/turf";
import { GeoJSONFeature } from "common/interfaces/GeoJSON";
import { Feature, GeoJsonProperties, Point } from "geojson";

export const isInnerOfFeature = <T>(
  point: Feature<Point, GeoJsonProperties>,
  feature: GeoJSONFeature<T>
) => {
  try {
    const featurePolygon = polygon(feature.geometry.coordinates);

    if (featurePolygon) {
      for (const coordinates of featurePolygon.geometry.coordinates) {
        try {
          const individualPolygon = polygon([coordinates]);

          if (
            individualPolygon &&
            booleanPointInPolygon(point, individualPolygon)
          ) {
            return true;
          }
        } catch {
          // ignore errors
        }
      }
    }
  } catch {
    // ignore errors
  }

  return false;
};

export const getPublicEstateIdComponent = (publicEstateId: string) => {
  return {
    actualPublicEstateId: publicEstateId.substring(0, 36),
    companyIndex: publicEstateId.substring(36) || ""
  };
};

export const getPublicUrl = (url: string, companyIndexes: string[]) => {
  const urlObj = new URL(url);
  const joinedPublicEstateIdsOnUrl = urlObj.pathname.split("/").at(-1) ?? "";
  const publicEstateIdsOnUrl = joinedPublicEstateIdsOnUrl.split(",");

  const joinedPublicEstateIds = publicEstateIdsOnUrl
    .map(
      (publicEstateId, index) =>
        `${getPublicEstateIdComponent(publicEstateId).actualPublicEstateId}${companyIndexes[index] || ""}`
    )
    .join(",");

  urlObj.pathname = urlObj.pathname
    .replace(joinedPublicEstateIdsOnUrl, joinedPublicEstateIds)
    .replace(/\/detail/, "/pub");

  return urlObj.href;
};
